import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 2C15.2384 2 17.8776 4.56557 17.9959 7.77506L18 8H19C20.0544 8 20.9182 8.81588 20.9945 9.85074L21 10V20C21 21.0544 20.1841 21.9182 19.1493 21.9945L19 22H5C3.94564 22 3.08183 21.1841 3.00549 20.1493L3 20V10C3 8.94564 3.81588 8.08183 4.85074 8.00549L5 8H6C6 4.68629 8.68629 2 12 2ZM19 10H5V20H19V10ZM12 12C13.1046 12 14 12.8954 14 14C14 14.6834 13.6573 15.2866 13.1344 15.6474L13 15.7324V17C13 17.5523 12.5523 18 12 18C11.4872 18 11.0645 17.614 11.0067 17.1166L11 17V15.7324C10.4022 15.3866 10 14.7403 10 14C10 12.8954 10.8954 12 12 12ZM12 4C9.79086 4 8 5.79086 8 8H16C16 5.79086 14.2091 4 12 4Z" })
});
export default SvgLockLine;
